import React, { useEffect, useState } from 'react';
import { getOpaAttendantPhoto } from '../../services/apiService';

const OpaAvatar = ({ name = '', fotoUrl, className = '', imageClassName = '' }) => {
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        setImageSrc(null);
        if (typeof fotoUrl !== 'string' || !fotoUrl) return undefined;
        if (fotoUrl.startsWith('data:image/')) {
            setImageSrc(fotoUrl);
            return undefined;
        }
        if (!/^https?:\/\//i.test(fotoUrl)) return undefined;

        const controller = new AbortController();
        let objectUrl;
        getOpaAttendantPhoto(fotoUrl, controller.signal)
            .then(blob => {
                if (controller.signal.aborted) return;
                objectUrl = URL.createObjectURL(blob);
                setImageSrc(objectUrl);
            })
            .catch(() => {
                // Fotos hospedadas fora do OPA podem ser públicas.
                if (!controller.signal.aborted) setImageSrc(fotoUrl);
            });

        return () => {
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [fotoUrl]);

    return (
        <div className={`rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/50 dark:to-indigo-900/50 flex items-center justify-center text-blue-600 dark:text-blue-400 font-bold overflow-hidden flex-none ${className}`}>
            {imageSrc ? (
                <img src={imageSrc} alt={name} className={`h-full w-full object-cover ${imageClassName}`} onError={() => setImageSrc(null)} />
            ) : name.substring(0, 2).toUpperCase()}
        </div>
    );
};

export default OpaAvatar;
